import {
  ITrainerHorseDetailsPageActions,
  SET_PREFERRED_CONDITIONS_STATE,
  SET_MAP_POPUP_STATE
} from "store/actions/trainerHorseDetailsPage";
import ITrainerHorseDetailsPageState from "interfaces/TrainerHorseDetailsPageState";

const initialState: ITrainerHorseDetailsPageState = {
  preferredConditionsState: false,
  mapPopupState: false
};

export default (
  state: ITrainerHorseDetailsPageState = initialState,
  action: ITrainerHorseDetailsPageActions
): ITrainerHorseDetailsPageState => {
  switch (action.type) {
    case SET_PREFERRED_CONDITIONS_STATE:
      return {
        ...state,
        preferredConditionsState: action.preferredConditionsState
      };
    case SET_MAP_POPUP_STATE:
      return {
        ...state,
        mapPopupState: action.mapPopupState
      };
    default:
      return state;
  }
};
